<template>
    <el-form label-position="top" :rules="rules" ref="ruleFormRef" :model="values" @submit.prevent>
        <div class="row ps-6 pe-6 pt-4">
            <div class="col-sm-5">
                <p class="font-weight-bold p-header p-2 w-100 lead mb-0">Ümumi məlumat</p>
                <br>
                <div class="row">
                    <el-form-item label="Müqavilə tarixi" class="w-50" prop="contractDate" label-position="top">
                        <el-date-picker format="DD.MM.YYYY" v-model="values.contractDate" class="w-100" type="date"
                            placeholder="Pick a day" />
                    </el-form-item>
                </div>
                <div class="row">
                    <el-form-item label="Müqavilə nömrəsi" class="w-50" label-position="top">
                        <el-input v-model="values.contractFullNumber" />
                    </el-form-item>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <el-form-item label="Başlanma tarixi" prop="quotaDate" label-position="top">
                            <el-date-picker format="DD.MM.YYYY" v-model="values.startDate" class="w-100" type="date"
                                placeholder="Pick a day" />
                        </el-form-item>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-6">
                        <el-form-item label="Bitmə tarixi" prop="quotaDate" label-position="top">
                            <el-date-picker format="DD.MM.YYYY" v-model="values.endDate" class="w-100" type="date"
                                placeholder="Pick a day" />
                        </el-form-item>
                    </div>
                </div>

                <br>
                <p class="font-weight-bold p-header p-2 w-100 lead mb-0">Əlavələr</p>
                <br>

                <div class="row">
                    <el-form-item label="Qeydlər" label-position="top">
                        <el-input v-model="values.descr" :autosize="{ minRows: 2, maxRows: 4 }"
                            type="textarea" />
                    </el-form-item>
                </div>

                <div class="row">
                    <el-form-item label="Əlavə şərtlər" label-position="top">
                        <el-input v-model="values.addCond" :autosize="{ minRows: 2, maxRows: 4 }"
                            type="textarea" />
                    </el-form-item>
                </div>
            </div>
            <div class="col-sm-2"></div>
            <div class="col-sm-5">
                <div>
                    <p class="font-weight-bold p-header p-2 w-100 lead mb-0">Şirkət</p>

                    <br>
                    <el-form-item label-position="top">
                        <partner-finder :onlyC="true" :propvalue="values.insured" :sector="true"
                            @change-value="value => values.insured = value">
                        </partner-finder>
                    </el-form-item>
                </div>
                <br>
                <div>
                    <p class="font-weight-bold p-header p-2 w-100 lead mb-0">Məsul şəxs</p>
                    <br>
                    <el-form-item label-position="top">
                        <partner-finder :onlyP="true" :propvalue="values.resp"
                            @change-value="value => values.resp = value">
                        </partner-finder>
                    </el-form-item>
                </div>
                <br>
            </div>
        </div>
        <el-affix position="bottom" :offset="5">
            <div class="pe-6" style="background-color: white; display: flex; justify-content: end;">
                <soft-button @click="SubmitForm()" color="success">Daxil et</soft-button>
            </div>
        </el-affix>
    </el-form>
</template>
<script>
import SoftButton from "@/components/SoftButton.vue";
import PartnerFinder from "@/project/Components/PartnerFinder.vue";

export default {
    components: {
        SoftButton,
        PartnerFinder
    },
    props: {
        object: Object,
        editing: Boolean,
        insert: Boolean,
    },
    data() {
        return {
            values: { quotaDate: new Date(), currencyId: "1", period: 36, payType: "1" },
            banks: [],
            companies: [],
            searched: false,
            rules: {
                period: [
                    { required: true, message: 'Mütləq sahə', trigger: 'blur' },
                    { type: 'number', min: 36, message: 'Minimum 36 ay', trigger: 'blur' }
                ]
            },
        }
    },
    mounted() {
        if (this.editing == true) {
            this.values = { ...this.object }
        }
    },
    methods: {
        SubmitForm() {
            this.$refs.ruleFormRef.validate(valid => {
                if (valid) {
                    window.location.href = window.location.origin + '/documents/contract/' + 3
                }
            });
        },
    },
    watch: {
        'values.insured'() {
            this.values.holder = { ...this.values.insured }
        }
    }
}
</script>